module.exports = __webpack_public_path__ + "img/head-side-medical.952064e0.svg";